import React, { Component } from "react";

import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import ButtonIcon from "../../../button";
import { ListTabButton } from "../../../common/list-tab/list-tab-button.component";
import { OrderRequestDetails } from "./order-request-details.component";
import { QuotationEmailValidator } from "./quotation-email-validator.component";
import { Selected_Index } from "../../../../constants/internal-constants";
export class AdditionalDetails extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.state={
      show:false,
      clearData:false, 
      selected:[],
      orderSubmitted:"",
      selectedTwo:[],
      selectedIndex:"0",
      listTabInfo:{
        Tab:[
            {
                "id":"0",
                "label":"Order Request Details"            
            },
            {
                "id":"1",
                "label":"Email to Vendor"           
            }
        ]
    }
    }
  }

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };
  
  resetClearData(item) {
    this.setState({clearData:item})
  }

   FilterIndex(tabIndex){    
    this.setState({selectedIndex:tabIndex});  
  }

  showModal(value) {
    this.setState({show:value});
  }
 
  render(){
    const {show}=this.state;
    return(
      <>
      <ButtonIcon onClick={this.handleShow.bind(this)} iconLeft="file-lines" iconSize="17px" customClassName="order-summary-btn" labelName="Additional Information"/>
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container quotation-modal-container"
      >
        <Modal.Header closeButton>
          <Modal.Title>Order Submitted</Modal.Title>
        </Modal.Header>
        <Modal.Body>
           <ListTabButton listData={this.state.listTabInfo.Tab} selectedIndex={this.state.selectedIndex} FilterIndex={this.FilterIndex.bind(this)}/>
            {
              this.state.selectedIndex===Selected_Index.i_Zero &&
              <OrderRequestDetails />
            }

            {
              this.state.selectedIndex===Selected_Index.i_One &&
              <QuotationEmailValidator datatable={this.props.datatable} showModal={this.showModal.bind(this)} />
            }
                 
        </Modal.Body>       
      </Modal>

      </>
    );
  }
}
